import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth.slice';
import userSlice from './slices/user.slice';
import roleSlice from './slices/role.slice';
import masterSlice from './slices/master.slice';
import uiSlice from './slices/ui.slice';
import permissionsSlice from './slices/permissions.slice';
import lobSlice from './slices/lob.slice';
import productSlice from './slices/product.slice';
import notificationSlice from './slices/notification.slice';
import notificationAuditSlice from './slices/notificationAudit.slice';
import auditSlice from './slices/audit.slice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    role: roleSlice,
    master: masterSlice,
    ui: uiSlice,
    permissions: permissionsSlice,
    lob: lobSlice,
    product: productSlice,
    notification: notificationSlice,
    notificationAudit: notificationAuditSlice,
    audit: auditSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
